import type { TFunction } from "i18next";
import { formatDateTime } from "../../../lib/datetime/displayDateTime";

export const getIntentRuleCols = (t: TFunction) => [
  {
    name: t("intentRules.cols.intent"),
    selector: (row: any) => row.intent,
    sortable: true,
  },
  {
    name: t("intentRules.cols.targetIndex"),
    selector: (row: any) => row.analysisRule?.targetIndex || "",
    sortable: true,
  },
  {
    name: t("intentRules.cols.searchType"),
    selector: (row: any) => row.analysisRule?.searchType || "",
    sortable: true,
  },
  {
    name: t("intentRules.cols.searchValue"),
    selector: (row: any) => row.analysisRule?.searchValue || "",
    sortable: false,
  },
  {
    name: t("intentRules.cols.timeField"),
    selector: (row: any) => row.analysisRule?.timeField || "",
    sortable: false,
  },
  {
    name: t("intentRules.cols.aggregation"),
    selector: (row: any) => row.analysisRule?.aggregationType || "",
    sortable: false,
  },
  {
    name: t("intentRules.cols.createdBy"),
    selector: (row: any) => row.createdBy || "",
    sortable: true,
  },
  {
    name: t("intentRules.cols.createdDate"),
    selector: (row: any) =>
      row.createdDate ? formatDateTime(row.createdDate) : "",
    sortable: true,
  },
];

const IntentRuleModel = {
  get cols() {
    return getIntentRuleCols(((key: string) => key) as TFunction);
  },
  createDialogOpts: (t: TFunction) => ({
    submitButtonText: t("common.create"),
    cancelButtonText: t("common.cancel"),
    title: t("intentRules.createTitle"),
    content: t("intentRules.createContent"),
  }),
  editDialogOpts: (t: TFunction) => ({
    submitButtonText: t("common.update"),
    cancelButtonText: t("common.cancel"),
    title: t("intentRules.editTitle"),
    content: t("intentRules.editContent"),
  }),
  WARNING: { color: "warning", icon: "warning", title: "", content: "", info: "" },
  ERROR: { color: "error", icon: "error", title: "", content: "", info: "" },
  SUCCESS: { color: "success", icon: "success", title: "", content: "", info: "" },
  async message(type: any, title: any, content: any, info: any) {
    return new Promise((resolve) => {
      type.title = title;
      type.content = content;
      type.info = info;
      resolve(type);
    });
  },
};

export default IntentRuleModel;
